import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';

export interface AdminTwoFactorDevice {
  user_id: number;
  user_email: string;
  is_confirmed: boolean;
  confirmed_at: string | null;
  last_used_at: string | null;
  created_at: string;
}

@Injectable()
export class ProfileService {
  private apiEndpoint = '/rest-api/v1/profiles/';

  constructor(private http: HttpClient) {}

  get = id => this.http.get(this.apiEndpoint + id);

  profilesSearch = (params = {}) => this.http.get('/rest-api/v1/profiles/search', {params: params});

  updateProfileContact = (id, body) => this.http.post(`/rest-api/v1/admin/company-users/${id}/contact-details`, body);

  searchProfiles = params => {
    return this.http.get(`/rest-api/v1/profiles/search`, {params});
  };

  getAdmins = () => this.http.get('/rest-api/admin-panel/api/v1/admins');

  addAdmin = id => this.http.put(`/rest-api/admin-panel/api/v1/admins/${id}`, {});

  deleteAdmin = id => this.http.delete(`/rest-api/admin-panel/api/v1/admins/${id}`, {});

  // Authenticator (2FA) devices of admins, super admin only; keyed by user id, listed with the user's email.
  getAdminTwoFactorDevices = () => this.http.get<AdminTwoFactorDevice[]>('/rest-api/admin-panel/api/v1/admin/two-factor/devices');

  resetAdminTwoFactor = (userId: number) =>
    this.http.delete(`/rest-api/admin-panel/api/v1/admin/two-factor/devices/${userId}`);
}
